module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-personal"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('personal_client')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_addjoin')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_return')))]), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.addNetwork
    }
  }, [_vm._v(_vm._s(_vm.$t('personal_add')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networks.length > 0) ? _c('a', {
    staticClass: "u-link kiwi-personal-existing-networks",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStateBrowser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('personal_saved')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kiwi-aboutnew-content",
    class: {
      'kiwi-aboutnew-content--open': _vm.about_open
    },
    domProps: {
      "innerHTML": _vm._s(_vm.aboutContent)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-aboutnew"
  }, [_c('div', {
    staticClass: "kiwi-aboutnew-sep"
  }), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.about_open = !_vm.about_open
      }
    }
  }, [_vm._v("Link to your network / channel")]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-aboutnew-help"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.about_open = !_vm.about_open
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-sponsor"
  }, [_vm._v("\n        Sponsored by "), _c('a', {
    attrs: {
      "href": "//www.privateinternetaccess.com/"
    }
  }, [_vm._v("PrivateInternetAccess")]), _vm._v(" "), _c('span', [_vm._v("Protect your internet with a VPN")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e064099!./~/vue-loader/lib/selector.js?type=template&index=0!./src/thirdparty/kiwiirccom.vue
// module id = 480
// module chunks = 2